import { Head } from '@inertiajs/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { AdminTracksIndex } from '@/types';
import { CreateTrackDialog } from './components/CreateTrackDialog';
import { TracksTable } from './components/TracksTable';

export default function Index({
  tracks,
  eventSlug,
  eventName,
  title,
}: AdminTracksIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-bold text-3xl tracking-tight">Tracks</h1>
            <p className="text-muted-foreground">
              Manage hackathon tracks for {eventName}
            </p>
          </div>
          <CreateTrackDialog eventSlug={eventSlug} />
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Tracks ({tracks.length})</CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <TracksTable eventSlug={eventSlug} tracks={tracks} />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
